module.exports = __webpack_public_path__ + "img/IMG_7041.ea474066.webp";